// extracted by mini-css-extract-plugin
module.exports = {"tagsInformation":"TagsInformation_tagsInformation__XTkMb","tags":"TagsInformation_tags__3Y4Wh","chips":"TagsInformation_chips__2pyps"};